import { useQuery, UseQueryResult } from 'react-query';
import type { ResponseFormat } from '../algebra/global';
import type { IVisitorHelproom } from '../algebra/waiting-room';
import { Http } from '../prelude/http';

export function useFetchHelpRoom(helproom_id: string | undefined): UseQueryResult<IVisitorHelproom> {
  return useQuery(
    ['HELPROOM', helproom_id],
    () => Http.Request<ResponseFormat<IVisitorHelproom>>('GET', `/helprooms/api/v1/visitor/helprooms.get?helproom_id=${helproom_id}`).then((res) => res.data),
    {
      enabled: helproom_id !== '' && helproom_id !== undefined,
    }
  );
}
